import './home.css';

const Home = () => (
  <div className="home_page">
    <h2>Welcome to Our page!</h2>
    <p className="home_text">
      According to Live science: Mathematics is the science that deals
      with the logic of shape, quantity and arrangement. Math is all around us,
      in everything we do. It is the building block for everything in
      our daily lives, including mobile devices, computers, software,
      architecture (ancient and modern), art, money, engineering and even sports.
      The more complex a society, the more complex the mathematical needs.
      Primitive tribes needed little more than the ability to count,
      but also used math to calculate the position of the sun and the physics of hunting.
      &quot;All the records — anthropological and historical — show that counting and,
      ultimately, numeral systems as a device for counting form the inception
      of the mathematical element in all cultures,&quot; Wilder wrote in 1968.
    </p>
    <br />
    <p className="home_text">
      Since the beginning of recorded history, mathematical discovery has been
      at the forefront of every civilized society, and math has been used by
      even the most primitive and earliest cultures. The need for math arose
      because of the increasingly complex demands from societies around the world,
      which required more advanced mathematical solutions, as outlined by mathematician
      Raymond L. Wilder in his book &quot;Evolution of Mathematical Concepts(opens in new tab)&quot;
      (Dover Publications, 2013).

      {' '}
    </p>
  </div>
);

export default Home;
